import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

let countryListUrl =
  "https://raw.githubusercontent.com/samayo/country-json/master/src/country-by-name.json";

export default store => {
  return {
    $store: store,
    getCountries() {
      this.$store.commit("loading", true);
      return axios({
        method: "get",
        url: countryListUrl
      })
        .then(res => {
          this.$store.commit("loading", false);
          return res.data;
        })
        .catch(err => {
          dispatchError(this.$store, err.message);
          throw err;
        });
    },
    getDashboard() {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/dashboards/?description=Brand"
        })
      )
        .then(res => {
          this.$store.commit("loading", false);
          return res.data;
        })
        .catch(err => {
          dispatchError(this.$store, err.message);
          throw err;
        });
    }
  };
};
